var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('a',{staticClass:"iconfont icon-telephone",attrs:{"href":"javascript:;"},on:{"click":_vm.openCallDialog}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }